import clsx from 'clsx'
import { MicIcon } from 'lucide-react'
import { useState } from 'react'
import { AudioDuration, Button } from '../../../../../components'

const MAX_AUDIO_DURATION_MS = 1000 * 60 // 1 minute

export type ChatAudioInputProps = {
  onSendAudio: (file: File) => void
}

export function ChatAudioInput (props: ChatAudioInputProps) {
  const { onSendAudio } = props

  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null)
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(null)
  const [startDate, setStartDate] = useState<Date | null>(null)

  const handleStart = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    const recorder = new MediaRecorder(stream)
    recorder.start()
    setStartDate(new Date())
    recorder.ondataavailable = (event) => {
      const mediaType = recorder.mimeType || event.data.type

      const extension = mediaType.split(';')[0].split('/')[1]
      const blob = new Blob([event.data])
      const file = new File([blob], `audio.${extension}`, { type: mediaType })

      onSendAudio(file)
    }
    setMediaStream(stream)
    setMediaRecorder(recorder)
  }

  const handleStop = () => {
    mediaRecorder?.stop()
    setStartDate(null)
    setMediaStream(null)
    setMediaRecorder(null)
  }

  return (
    <>
      <Button
        type="button"
        color="primary"
        circle
        ghost
        onClick={mediaStream ? handleStop : handleStart}
      >
        <MicIcon
          size={20}
          className={clsx(
            mediaStream ? 'text-red-500' : 'text-primary'
          )}
        />
      </Button>

      {startDate && (
        <AudioDuration
          className="text-xs ml-1"
          startDate={startDate}
          duration={MAX_AUDIO_DURATION_MS }
          handleStop={handleStop}
        />
      )}
    </>

  )
}
